<template>
  <div class="animated fadeIn">
   <b-card>
    <div slot="header">
      <strong>My Information</strong>
      <span class="float-right">{{model.last_visit | datetime}}@{{model.last_addr || '-'}}</span>
    </div>
    <b-row v-if="model.permissions == 1">
      <b-col md="12">
        <b-form-group class="text-center">
          <label for="ph_manage">Group Manage</label>
          <!-- <b-button block variant="primary" @click="redir" :disabled="lock"> go to  Group Manage ( {{model.groupname}} ) </b-button> -->
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label for="ph_created_at" v-b-tooltip.hover title="Login ID.">Joined_at</label>
          <p>{{model.created_at | datetime}}</p>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <!-- <b-form-group>
          <label for="ph_nickname" v-b-tooltip.hover title="Nick name">Nick Name</label>
          <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
        </b-form-group> -->
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label for="ph_username" v-b-tooltip.hover title="Login ID.">E-Mail(ID)</label>
          <b-form-input :disabled="true" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for="ph_nickname" v-b-tooltip.hover title="Nick name">Nick Name</label>
          <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="!lock">
      <b-col md="6" >
        <b-form-group>
          <label for="ph_pass">Current Password</label>
          <b-form-input type="password" id="ph_pass" v-model="model.now_password" :plaintext="lock"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <label for="ph_is_otp_use">OTP Active</label>
          <b-form-group>
            <b-button block @click="genOtp()" :variant=" toggleOtp ? 'primary' : 'secondary'" :pressed.sync="toggleOtp" :disabled="lock"> {{toggleOtp ? 'Enabled' : 'Disabled' }} </b-button>
            <!-- <c-switch v-on:change="otp_active"  :disabled="lock" color="success" label variant="pill"/><br> -->
          </b-form-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="!lock">
      <b-col md="6" >
        <b-form-group>
          <label for="ph_pass_new">New Password</label>
          <b-form-input type="password" id="ph_pass_new" v-model="model.new_password" :plaintext="lock"></b-form-input>
          <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
          <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
          <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
          <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
          <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
            Min Length : 10
          </b-badge>
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="model.new_password">
        <b-form-group>
          <label for="ph_pass2"> Password repeat </label>
          <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <hr v-if="toggleOtp">
    <b-row>
      <b-col md="6" v-if="toggleOtp" class="text-center">
        <b-form-group v-if="qrcode">
          <img :src="qrcode">
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="toggleOtp && qrcode && !lock">
        <label for="ph_qrcode">OTP Code</label>
        <b-form-input type="text" id="ph_qrcode" v-model="model.otp_pin" :plaintext="lock"></b-form-input>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label for="ph_nickname">Nickname</label>
          <b-input type="text" v-model="model.nickname" :plaintext="lock"></b-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="country" label-for="ph_country" v-b-tooltip.hover title="country.">
          <v-select :readonly="true" @input="set_country" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="timezone" label-for="ph_timezone" v-b-tooltip.hover title="timezone.">
          <v-select :readonly="true" @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
        </b-form-group>
      </b-col>
    </b-row>
    <hr>
    <template v-if="lock">
      <template>
        <b-button class="float-right" size="sm" variant="warning" @click="edit"> Edit </b-button>
      </template>
    </template>
    <template v-else>
      <b-button class="float-right" size="sm" variant="success" @click="save"> Save </b-button>
      <b-button class="float-right" size="sm" variant="default" @click="cancel"> Cancel </b-button>
    </template>
    </b-card>
    <hr>
    <!-- <log-Login-List v-if="model.id" :user="model" :type="'partner'"></log-Login-List> -->


  </div>
</template>

<script>
import { Api, auth } from '@/service';

import * as forge from 'node-forge'
import reg from '@/reg'
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import logLoginList from '../../Log/login/Login.List.Partner'
import speakeasy from 'speakeasy';
import QRCode from 'qrcode';
import codes from '@/codes';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: ''
});

export default {
  components: { cSwitch, QRCode, logLoginList, vSelect },
  data : () => ({
    codes : codes,
    model : { group : {} },
    region : {
      language : codes.language_default,
      country : codes.country_default,
      timezone : codes.timezone_default
    },
    password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
    origin : '',url : '', value: '', urlurl : '', toggleOtp : false,
    size: 300, qrcode : '',so : default_opt(), confirm: false, add: false, lock: true, group_list: undefined, log : {}}),
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'username', label: 'User', sortable: false },
        { key: 'addr', label: 'ADDR', sortable: false },
        { key: 'created_at', label: 'Date', sortable: false },
      ];
    },
  },
  methods: {
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } this.model.language = x.value },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new_password && reg.reg_number.test(this.model.new_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new_password && reg.reg_alphabat_upper.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new_password && reg.reg_alphabat_lower.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new_password && reg.reg_spacial.test(this.model.new_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new_password && this.model.new_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },

    async genOtp(){
      if(!this.toggleOtp || this.qrcode) { this.model.otp_pin = undefined; return }
      if(this.model.is_otp) { console.log("not generate QRcode"); return; }
      try {
        let key = (await Api.auth.otpGen({})).otpkey;
        let address = speakeasy.otpauthURL({ issuser : 'f1security', encoding: 'base32', digits : 6, period : 30, algorithm : 'sha1', secret: key, label: `F1-UWSS:Partner:${this.model.username}`});
        this.qrcode = await QRCode.toDataURL(encodeURI(address))
        this.model.otpkey = key;
        console.log("created", "otp qr code")
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    async registerOtp(m){
      try {
        if(!m.otp_pin) { return this.$toastr.e('OTP code', 'Require'); }
        // { otp_key : "", otp_pin : "", password : "" }
        let rs = await Api.auth.otpRegister(m)
        if(!rs) { return this.$toastr.w('failed', 'update') }
        this.$toastr.s('registed OTP done!', 'update')
        this.cancel();
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText, "registed OTP"); }
    },
    async unregisterOtp(m){
      try {
        // { password : '' }
        let rs = await Api.auth.otpUnregister(m)
        if(rs) {
          this.$toastr.s('unregistered OTP done!', 'update')
        } else {
          this.$toastr.e('unregistered OTP failed!', 'update')
        }
        this.cancel();

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText, "unregistered OTP"); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    // getItems: function(ctx) { return this.get(ctx); },
    cancel() { this.qrcode = ""; this.$router.replace({ name: 'profile' }); },
    edit() { this.$router.push({ name: 'profile', params: { tag: 'edit' }}); },
    async save() {
      let model = {};

      if(!this.model.now_password) { return this.$toastr.e('Current Password', 'Required')}
      else { model.password = forge.sha256.create().update(this.model.now_password).digest().toHex(); }
      // if(this.model.username != auth.profile.username && !(this.model.new_password || '').length) { return this.$toastr.e('Password is required when changing email (ID).'); }
      if(!this.model.id && !this.model.new_password) { return this.$toastr.e('password repeat', 'Required'); }
      if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) { return this.$toastr.e('Password repeat not match', 'Required'); }
      if(!this.toggleOtp) { this.model.otpkey = undefined; }
      if(this.model.new_password) {
        var rs = this.password_policy('all')
        if(rs.is_error) {
          var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
          return this.$toastr.e(`Please check password policy [${msg}] characters`);
        }
        model.new_password = forge.sha256.create().update(this.model.new_password).digest().toHex();
      }

      // set region
      if(!this.region.country) { return this.$toastr.e('Country Required.'); }
      if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
      if(!this.region.language) { return this.$toastr.e('Language Required.'); }

      let region = {};
      region.country = this.region.country.value
      region.language = this.region.language.value
      region.timezone = this.region.timezone.value

      try {
        if(this.toggleOtp != this.model.is_otp) {
          if(this.toggleOtp) { await this.registerOtp({ username : this.model.username, password : model.password, otp_key : this.model.otpkey, otp_pin : this.model.otp_pin, }); }
          else { await this.unregisterOtp({ password : model.password }); }
        }

        let rs = await Api.auth.update(Object.assign({}, this.model, model, region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.lock = true;
          this.get(this.$route.params.id);
        } else {
          this.$toastr.e('Saved', "failed");
        }
        this.cancel();
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.lock = false; }

    },
    async get({ id, tag } = this.$route.params) {
      console.log('profile.detail.vue', 'load item', id);
      delete this.model.new_password;
      delete this.model.new_password_repeat;
      this.add = false;
      this.lock = (tag !== 'edit');

      try {
        this.model = Object.assign({ group: {} }, this.model, await Api.auth.profile(auth.profile.id));
        this.model.is_otp = this.model.otpkey && this.model.otpkey.length ? true : false
        this.toggleOtp = this.model.is_otp;

        let is_done_country = false;
          codes.country.forEach(r => { if(is_done_country || !this.model.country) { return; } else if(r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language || !this.model.language) { return; } else if(r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) ; this.cancel(); }
    },
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('profile.detail.vue', 'created'); },
  destroyed() { console.log('profile.detail.vue', 'destroyed'); },
  mounted() { console.log('profile.detail.vue', 'mounted'); this.get(this.$route.params);  },
}
</script>
